const MEDAL_TONE = {
  1: { box: 'bg-gold text-paper', text: 'text-gold' },
  2: { box: 'bg-ink-300 text-ink-900', text: 'text-ink-700' },
  3: { box: 'bg-flag-dark text-paper', text: 'text-flag-dark' },
} as const

const Rank = ({
  rank,
  size = 'sm',
}: {
  rank: number | null | undefined
  size?: 'sm' | 'lg'
}) => {
  if (rank == null) {
    return (
      <span
        className={`font-mono num text-ink-300 shrink-0 ${
          size === 'lg' ? 'text-4xl' : 'text-sm w-8 text-right'
        }`}
      >
        —
      </span>
    )
  }
  const tone = MEDAL_TONE[rank as 1 | 2 | 3]
  if (size === 'lg') {
    return (
      <span
        className={`font-display font-extrabold leading-none tracking-tight num ${
          tone?.text ?? 'text-paper'
        }`}
        style={{ fontSize: 44 }}
      >
        {rank}.
      </span>
    )
  }
  if (tone) {
    return (
      <span
        className={`inline-flex items-center justify-center w-7 h-7 rounded-md font-display font-bold text-xs ${tone.box}`}
      >
        {rank}
      </span>
    )
  }
  return (
    <span className="font-mono num text-ink-500 text-sm w-7 text-right shrink-0">
      {rank}.
    </span>
  )
}

export default Rank
